import { useEffect, useState } from "react";
import { Utility } from "../../../../model/bill-settings/bill-settings";
import BillPageLayout from "../component/layout/BillPageLayout";
import styles from "../bills.module.scss";
import utilCardStyles from "../../../../common/components/xepp/utility-card/UtilityCard.module.scss";
import UtilityCard from "../../../../common/components/xepp/utility-card/UtilityCard";
import { VendingPageHistory } from "./VendingPageHistory";
import { useConfigLayout } from "../../../../hooks/useConfigLayout";
import { useLazyGetVendingUtilitiesQuery } from "../../../../service/utility-service";
import { SkeletonGrid } from "../../../../common/components/xepp/skeleton-loader/SkeletonLoader";
import EmptyState from "../../../../common/components/xepp/empty-state/EmptyState";
import { VendingActiveIcon } from "../../../../assets/icons";


export const VendingPage = () => {
	const [ getVendingUtilities, { data, isLoading, error} ] = useLazyGetVendingUtilitiesQuery();
	  const {
		updateLayout,
		selectedCountry 
	  } = useConfigLayout({ showCountrySelector: true,
		                   utility: null,
						   showExportButton: false,
						   showBreadCrumb: true });
    const [selectedUtility, setSelectedUtility] = useState<Utility| undefined>();

	useEffect(()=>{
		   if(selectedCountry?.isoCode) {
			getVendingUtilities(selectedCountry?.isoCode);
		   }
		}, [selectedCountry])

	function handleManageUtility(utility: Utility) {
		setSelectedUtility(utility);
		updateLayout({ showExportButton: true, showCountrySelector: false, utility: utility,  })
	}

	useEffect(() => {
			if (selectedUtility) {
				updateLayout({ goBackHandler: () => setSelectedUtility(undefined) });
			} else updateLayout({ goBackHandler: null, utility: null, showExportButton: false, showCountrySelector: true });
		}, [selectedUtility]);

	return (
		<BillPageLayout title={selectedUtility ? "Vending History": ""}>
            {selectedUtility ? <VendingPageHistory selectedUtility={selectedUtility} /> :
			<div className={styles.container}>
				{isLoading ? <SkeletonGrid /> :
				<div className={utilCardStyles.utilityGrid}>
				{(data && data.length === 0) ? <EmptyState icon={<VendingActiveIcon />} title='No utilities available' /> 
					 :  data?.map((utility: Utility) => (
							   	<div key={utility.utilityCode} className={utilCardStyles.utilityCardWrapper}>
									<UtilityCard logo={utility.imageUrl} name={utility.name} description={utility?.description ?? ""} onManage={() => handleManageUtility(utility)} />
								</div>
							))
						}
				</div> }
			</div>
			 }
		</BillPageLayout>
	);
};
